import { useAppSelector } from "store";

import { ModalWindow } from "components";
import { isStoreSelectionModalOpenSelector, toggleStoreSelectionModal } from "features";

import StoreSelectionModalForm from "./StoreSelectionModalForm";

const StoreSelectionModal = () => {
  const isModalOpen = useAppSelector(isStoreSelectionModalOpenSelector);

  return (
    <ModalWindow
      isOpen={isModalOpen}
      toggleAction={toggleStoreSelectionModal}
      title={<h2 className="store-selection-modal-title">Выберите магазин</h2>}
      classNames="modal-store-selection"
    >
      <StoreSelectionModalForm />
    </ModalWindow>
  );
};

export default StoreSelectionModal;

